import React from 'react';
import Div from "@jumbo/shared/Div";
import Link from "@mui/material/Link";
// import {ASSET_IMAGES} from "../../utils/constants/paths";


const Logo = ({mini, mode, sx}) => {
    return (
        <Div sx={{display: "inline-flex", ...sx}}>
            <Link href={'/dashboards/misc'}>
                {
                    !mini ?
                        <img src={ mode === "light" ? `${process.env.REACT_APP_IMAGES_PATH}/logo.png` : `${process.env.REACT_APP_IMAGES_PATH}/logo-white.png`} alt="Jumbo React" />
                        :
                        <img src={mode === "light" ? `${process.env.REACT_APP_IMAGES_PATH}/logo-short.png` : `${process.env.REACT_APP_IMAGES_PATH}/logo-short-white.png`} alt="Jumbo React" />
                }
            </Link>
        </Div>
    );
};

Logo.defaultProps = {
    mode: "light"
};

export default Logo;
